<template>
    <w-btn
        color="teal"
        :loading="loading"
        :block="block"
        :text="$t('common.import')"
        icon="mdi-import"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnImport',
    props: {
        loading: Boolean,
        block: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>